import React, {useEffect, useState, useRef } from "react";
import "./gridControls.scss";

const OverflowComponent = ({onClick, items}) => {
    const containerRef = useRef(null);
    const [visibleItems, setVisibleItems] = useState(items);

    useEffect(() => {
        const handleResize = () => {
            if(containerRef.current) {
                const conatinerWidth = containerRef.current.offsetWidth;
                const itemsPerRow = Math.floor(conatinerWidth /80);
                setVisibleItems(items.slice(0, itemsPerRow-1))
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () =>{
            window.removeEventListener('resize', handleResize);
        }
    }, [items])

    return <div ref={containerRef} onClick={onClick}>
        {visibleItems.map((item, index) => (<span className="multi-value-label" key={index}>{item}</span>))}
        {items.length > visibleItems.length && <span className="multi-value-label">+{items.length - visibleItems.length}</span>}
    </div>
}

export default OverflowComponent;